module.exports = Promise.all([__parcel__import__("hcvCl"), __parcel__import__("dhn9i")]).then(() => parcelRequire('g36Vt'));